export class PaymentInfoModel {
  public currencyCode: string;

  constructor(params: PaymentInfoModel) {
    this.currencyCode = params.currencyCode;
  }

  public static fromCartV1(currencyCode: string): PaymentInfoModel {
    return new PaymentInfoModel({currencyCode});
  }
}
